<template>
  <div class="mx-full border-t border-gray-900/10 py-12">
    <div class="mx-auto max-w-2xl lg:flex lg:max-w-none">
      <div class="lg:flex-auto pr-8">
        <h3 class="text-lg font-bold tracking-tight text-gray-900">
          {{ offering.name }}
        </h3>
        <p class="mt-6 text-base leading-7 text-gray-600">
          {{ offering.summary }}
        </p>
        <p v-if="offering.free" class="mt-6 flex items-baseline justify-left gap-x-2">
          <span class="text-lg font-bold tracking-tight text-gray-900">
            Kostenlos
          </span>
        </p>
        <div v-if="!offering.free && offering.contractor && !lifetimeaccess">
          <p class="mt-6 flex items-baseline justify-left gap-x-2">
            <span class="text-lg font-bold tracking-tight text-gray-900 whitespace-nowrap">
              {{ offering.monthly }} EURO
            </span>
            <span class="text-sm font-semibold leading-6 tracking-wide text-gray-600">
              monatliche Abrechnung
            </span>
          </p>
          <p class="flex items-baseline justify-left gap-x-2">
            <span class="text-lg font-bold tracking-tight text-gray-900 whitespace-nowrap">
              {{ offering.annual }} EURO
            </span>
            <span class="text-sm font-semibold leading-6 tracking-wide text-gray-600">
              jährliche Abrechnung <br/>(17% gespart)
            </span>
          </p>
        </div>
        <!-- #TODO switch to else if or other for better readability -->
        <!-- CASE: PAID OFFERING IS ASSOCIATED AND USER IS CONTRACTOR -->
        <div v-if="!offering.free && offering.associated && offering.contractor  && !lifetimeaccess" class="block w-full">
          <DeletePodcastContract :id="parent" @success="action" class="mt-6" />
        </div>
        <!-- CASE: PAID OFFERING IS NOT ASSOCIATED AND USER IS SUBSCRIBED -->
        <div v-if="!offering.free && !offering.associated && offering.subscribed  && !lifetimeaccess" class="block w-full">
          <CreatePodcastContract :id="parent" @success="action" class="mt-6" />
        </div>
        <!-- CASE: PAID OFFERING IS NOT ASSOCIATED AND USER IS NOT SUBSCRIBED -->
        <div v-if="!offering.free && !offering.associated && !offering.subscribed  && !lifetimeaccess" class="block w-full">
          <SubscribePodcastPlan :href="offering.steady" class="mt-6" />
        </div>
        <!-- CASE: PAID OFFERING IS ASSOCIATED AND USER IS NOT CONTRACTOR -->
        <div v-if="!offering.free && offering.associated && !offering.contractor && !lifetimeaccess" class="block w-full">
          <span class="text-lg font-bold tracking-tight text-gray-900">
            <div class="block w-full">
              <p class="mt-6 block w-full rounded-md bg-gray-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-600">
                Dieser Podcast wurde freigeschaltet von: {{ offering.contractorEmail }}
              </p>
            </div>
          </span>
        </div>
        <!-- CASE: USER HAS LIFETIMEACCESS -->
        <div v-if="lifetimeaccess" class="block w-full">
          <span class="text-lg font-bold tracking-tight text-gray-900">
            <div class="block w-full">
              <p class="mt-6 block w-full rounded-md bg-gray-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-600">
                Dieser Podcast wurde freigeschaltet.
              </p>
            </div>
          </span>
        </div>
      </div>
      <div class="p-2 lg:mt-0 lg:w-full lg:max-w-md lg:flex-shrink-0">
        <ul role="list" class="grid grid-cols-1 gap-4 text-sm leading-6 text-gray-600 sm:grid-cols-1 sm:gap-2">
          <li v-for="feature in offering.features" :key="feature" class="flex gap-x-3">
            <CheckIcon class="h-6 w-5 flex-none text-teal-600" aria-hidden="true" />
            {{ feature }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>


<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const props = defineProps({offering: Object,  lifetimeaccess: { type: Boolean, default: false}});

const emits = defineEmits(['action']);

const store = useStore();

const parent = computed(() => store.getters['context/context'].id);

const action = () => emits('action');
</script>
